export default ['staging', 'production'].includes(process.env.FEEDBACK_ENV);
